import {SET_ACCOUNT_ID} from "./actionTypes";

export const setAccountId = (content) => ({
    type: SET_ACCOUNT_ID,
    payload: content
});
